import AppError from 'errors/app-error'

export default class ProgramNameEmptyError extends AppError {
  constructor() {
    super()
    this.statusCode = 422
    this.message = 'Program name can not be empty.'
  }
}
